export default Object.freeze({
    DISCLAIMER_AGREED: "MS_DISCLAIMER_AGREED"
});